// extracted by mini-css-extract-plugin
export var Badges = "Home-module--Badges--DXgqQ";
export var BottomFeatures = "Home-module--BottomFeatures--5OOOw";
export var CapterraBadge = "Home-module--CapterraBadge--GlEGm";
export var Container = "Home-module--Container--k1HSc";
export var G2 = "Home-module--G2--gdSX7";
export var Home = "Home-module--Home--Or765";